import { DeleteIcon } from '@chakra-ui/icons';
import { Flex, IconButton, Icon } from '@chakra-ui/react';
import GlobalFilter from 'plugins/DITable/filters/GlobalFilter';
import icons from 'shared/icons';
import { tableToolbarStyle, iconTableStyle } from 'shared/styles';
import { intentionalyFloatingPromiseReturn } from 'utils/wrappers';
import { TProductKeywordsContainer } from '../ProductKeywordsContainer';

const TableToolbar = ({
    globalFilter,
    selectedProductKeywords,
    isExportLoading,
    isFetching,
    handleExport,
    handleAddProductKeywordOpen,
    onDeleteOpen,
    globalFilterHandler,
    readonly,
}: TProductKeywordsContainer) => {
    const handleDelete = () => {
        onDeleteOpen();
    };

    const PlusIcon = icons.plus;
    const DownloadIcon = icons.download;

    return (
        <Flex {...tableToolbarStyle}>
            <GlobalFilter globalFilter={globalFilter} setGlobalFilter={globalFilterHandler} />
            <IconButton
                {...iconTableStyle}
                aria-label="download excel"
                isLoading={isExportLoading || isFetching}
                onClick={intentionalyFloatingPromiseReturn(handleExport)}
                size="sm"
                icon={<DownloadIcon />}
            />
            <IconButton
                onClick={handleAddProductKeywordOpen}
                {...iconTableStyle}
                aria-label="add alias"
                size="sm"
                icon={<Icon as={PlusIcon} />}
                isDisabled={readonly}
            />

            <IconButton
                size="sm"
                isDisabled={selectedProductKeywords.length === 0 || readonly}
                {...iconTableStyle}
                onClick={handleDelete}
                aria-label="bulk delete"
                icon={<Icon as={DeleteIcon} />}
            />
        </Flex>
    );
};

export default TableToolbar;
